// extracted by mini-css-extract-plugin
export default {"customerServiceBox":"customerServiceBox___j7O7Q","qrCode":"qrCode___UNv0M","desc":"desc___F3CGO"};